import { Alert, Typography } from 'antd'
import type { ReactNode } from 'react'

type LearnMoreAlertProps = {
  message: ReactNode
  onLearnMore: () => void
}

/** The intro banner every Tenant Configuration tab shows above its grid. */
export const LearnMoreAlert = ({
  message,
  onLearnMore,
}: LearnMoreAlertProps) => (
  <Alert
    type='info'
    showIcon
    style={{ margin: '8px 12px', maxWidth: 720 }}
    message={
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        {/* The copy takes the slack so the link sits against the right edge on every tab,
            however long the sentence is. */}
        <span style={{ flex: 1 }}>{message}</span>
        <Typography.Link onClick={onLearnMore} style={{ flexShrink: 0 }}>
          Learn more
        </Typography.Link>
      </div>
    }
  />
)
